import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="rounded-2xl bg-gradient-to-br from-primary-600 via-primary-700 to-primary-800 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading font-black text-2xl md:text-4xl text-background-50 mb-3">{appData.title}</h2>
              <p className="text-primary-100 text-sm md:text-base mb-6">{appData.subtitle}</p>
              <ul className="flex flex-col gap-2 mb-6">
                {appData.features.map((f, i) => (
                  <li key={i} className="flex items-center gap-2 text-primary-100 text-sm">
                    <i className="ri-checkbox-circle-fill text-accent-400 text-base"></i>
                    {f}
                  </li>
                ))}
              </ul>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="w-full sm:w-auto px-8 py-3 bg-background-50 text-primary-700 font-bold text-sm rounded-lg hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-apple-fill mr-1.5"></i> App Store 下载
                </button>
                <button className="w-full sm:w-auto px-8 py-3 bg-primary-500/30 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-500/40 transition-colors cursor-pointer whitespace-nowrap border border-primary-400/30">
                  <i className="ri-android-fill mr-1.5"></i> Android 下载
                </button>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl bg-background-50 p-3">
                <img
                  src={appData.qrImage}
                  alt="扫码下载五一黑料网APP"
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="text-center text-primary-200 text-xs mt-2">扫码下载APP</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}